import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';

function CustomNavbar() {
    const [scrolled, setScrolled] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 50;
            setScrolled(isScrolled);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleNavClick = (section) => {
        setExpanded(false); // Chiude il menu mobile

        if (location.pathname !== '/') {
            // Se non siamo sulla home, naviga prima alla home
            navigate('/');
            // Aspetta che la navigazione sia completata, poi scrolla
            setTimeout(() => {
                const element = document.getElementById(section);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        } else {
            // Se siamo già sulla home, scrolla direttamente
            const element = document.getElementById(section);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    return (
        <Navbar
            expand="lg"
            fixed="top"
            expanded={expanded}
            onToggle={setExpanded}
            className={`custom-navbar ${scrolled ? 'scrolled' : ''}`}
        >
            <Container>
                <Navbar.Brand as={Link} to="/" className="brand-logo">
                    <div className="brand-container">
                        <div className="logo-container">
                            <img
                                src="/logo-bear.png"
                                alt="BearSoftware Logo"
                                className="brand-logo-img"
                            />
                        </div>
                        <span className="gradient-text">BearSoftware</span>
                    </div>
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" />

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link
                            onClick={() => handleNavClick('home')}
                            className={location.pathname === '/' ? 'active' : ''}
                        >
                            Home
                        </Nav.Link>

                        <Nav.Link
                            as={Link}
                            to="/services"
                            onClick={() => setExpanded(false)}
                            className={location.pathname === '/services' || (location.pathname.startsWith('/services/') && location.pathname !== '/services/consulting/consulenza-tecnica') ? 'active' : ''}
                        >
                            Servizi
                        </Nav.Link>

                        <Nav.Link
                            as={Link}
                            to="/services/consulting/consulenza-tecnica"
                            onClick={() => setExpanded(false)}
                            className={location.pathname === '/services/consulting/consulenza-tecnica' ? 'active' : ''}
                        >
                            Consulenza
                        </Nav.Link>

                        <Nav.Link
                            onClick={() => handleNavClick('about')}
                            className={location.pathname === '/' ? '' : ''}
                        >
                            Chi Siamo
                        </Nav.Link>

                        <Nav.Link
                            onClick={() => handleNavClick('what-i-do')}
                            className={location.pathname === '/' ? '' : ''}
                        >
                            Cosa Facciamo
                        </Nav.Link>

                        <Nav.Link
                            onClick={() => handleNavClick('contact')}
                            className="btn-gradient ms-2"
                        >
                            <span>Contattaci</span>
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default CustomNavbar;